import { Observable , throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { CurrentContextProvider } from '../services';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {

  constructor(private currentContextProvider: CurrentContextProvider, 
              private router: Router, 
              private snackBar: MatSnackBar) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
    .pipe(catchError((err, caught) => {
        if(err.status && err.status === 401 && !this.router.url.startsWith('/login')) {
            this.currentContextProvider.currentUser = null;
            this.router.navigate(['/login'], {queryParams: { originator: this.router.url }});
            this.snackBar.open('You have been logged out, please log in again to continue.', 'OK', { duration: 5000 });
        }      
        return throwError(err);
    }));
  }
}
